import React from 'react';
import { call, put, takeEvery } from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';

import { pushToast } from 'containers/ToastManager/actions';
import { commandWorkspacePluginVersionList } from 'containers/ConnectionManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { pluginId, major, minor, patch } = action;
  const authorPluginVersionUnpublish = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_AUTHOR_PLUGIN_VERSION_UNPUBLISH,
    pluginId,
    major,
    minor,
    patch,
  });

  if (authorPluginVersionUnpublish.type === constants.RTM_AUTHOR_PLUGIN_VERSION_UNPUBLISH_OK) {
    yield put(commandWorkspacePluginVersionList(pluginId));
  } else {
    yield put(
      pushToast({
        type: 'simple',
        message: <FormattedMessage {...messages.failedAuthorPluginVersionUnpublish} />,
      })
    );
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_AUTHOR_PLUGIN_VERSION_UNPUBLISH, catchErrors, sendRequest, connection);
}
